"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALUE_LIST_OVERFLOW_TOLERANCE_PX = exports.SEARCH_SKELETON_ROW_COUNT = exports.LIST_TOP_OFFSET = void 0;
exports.LIST_TOP_OFFSET = 8;
exports.SEARCH_SKELETON_ROW_COUNT = 5;
exports.VALUE_LIST_OVERFLOW_TOLERANCE_PX = 2;
